<div class="notification">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-4">
      <div class="vs-text-field">
        <label>{{ "orderCheckOut.orderAknowledge" | cxTranslate }}</label>
        <!-- <strong>user@qwe.com</strong> -->
        <strong>{{
          cartOrderReviewObj?.notificationDetails?.orderAckEmail
        }}</strong>
      </div>
    </div>
<!--  Business requirement to remove invoiceEmail and shipNotificationEmail
    <div class="col-lg-4 col-md-4 col-sm-4">
      <div class="vs-text-field">
        <label>{{ "orderCheckOut.invoiceEmailLbl" | cxTranslate }}</label>
         <strong>user@qwe.com</strong>
        <strong>{{
          cartOrderReviewObj?.notificationDetails?.invoiceEmail
        }}</strong>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4">
      <div class="vs-text-field">
        <label>{{ "orderCheckOut.shipNotiEmail" | cxTranslate }}</label>
        <strong>{{
          cartOrderReviewObj?.notificationDetails?.shipNotificationEmail
        }}</strong>
      </div>
    </div> -->

    <div class="upload mt-3 mb-3">
      <div class="text">{{ "orderCheckOut.addAttachement" | cxTranslate }}</div>
    </div>

    <!--  START    -->
    <div
      id="fileInfo"
      class="fileInfo-section mt-30"
      *ngFor="let file of cartOrderReviewObj?.attachments"
    >
      <i class="material-icons material-icons-custom">receipt</i>
      <span id="para11">{{ file.realFileName }}</span>
      <span id="para22">{{ convertFileRetain(file.attachmentSizes) }}</span>
    </div>
    <!--   end     -->

    <div class="upload mt-3">
      <span>{{ "orderCheckOut.csrReviewConfirmation" | cxTranslate }}</span
      ><br />
      <!-- <strong>- Yes</strong> -->
      <strong *ngIf="cartOrderReviewObj?.isCsrReviewNeeded">{{
        "orderCheckOut.yesLbl" | cxTranslate
      }}</strong>
      <strong *ngIf="!cartOrderReviewObj?.isCsrReviewNeeded">{{
        "orderCheckOut.noLbl" | cxTranslate
      }}</strong>
    </div>
    <div class="vs-text-area mt-3 mb">
      <label>{{ "orderCheckOut.csrReviewLbl" | cxTranslate }}</label>
      <strong *ngIf="cartOrderReviewObj?.isCsrReviewNeeded">{{
        cartOrderReviewObj?.csrReviewReason
      }}</strong>
      <strong *ngIf="!cartOrderReviewObj?.isCsrReviewNeeded"></strong>
    </div>
  </div>
</div>
